query EntityDocumentSearch(
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $first: Int
  $after: Cursor
  $invoiceSigningSearchSearchRequest: SearchRequestInput
  $isLinkSearch: Boolean
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
) {
  entityDocumentSearch(
    isSigningSearch: $isSigningSearch
    isHistorySearch: $isHistorySearch
    first: $first
    after: $after
    searchRequest: $invoiceSigningSearchSearchRequest
    isLinkSearch: $isLinkSearch
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      id
      entityId
      _documentContents
      _isAccountingDocument
      _isDocumentAmountApplied
      entityDocumentTypeId
      fileIndexInformation
      _isDocumentTypeUpdatable
      comment
      documentTypeId
      documentStatusType {
        statusType
      }
      _isDocumentAmountAvailable
      currency {
        isoCode
      }
      _documentPoolName
      indexAmount
      indexCurrencyId
      indexDescription
      indexReferenceNumber
      indexTransactionDate
      _isReportingDocument
      _fileName
      _fileType
      _fileViewer
      _createdDate
      _createdByUserName
      _isDocumentShare
      fileReference
      iconType
      _fileSize
      rowSecurityId
      entityDocumentSecureRowLevels {
        name
        securityLevel
      }
      _uploadDate
      _rowTimestamp
      _isLoading
      _isDeletable
      _isUpdatable
      _isProtected
      _isSelected
      documentAppliedAmount
      _documentType
      documentTypes {
        transactionTypeId
        documentType
        _isMultiDocumentBundleAllowed
        _isAppliableDocumentType
      }
      indexName
      _uploadedByUser
      _uploadedByUserid
      _isVerified
      _verifiedUserName
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
    }
  }
}
